Bingo.GalleryManager = {};

Bingo.GalleryManager.BRICK_SELECTOR = 'div.brick';
Bingo.GalleryManager.ITEM_SELECTOR = 'div.item';
Bingo.GalleryManager.ACTIVE_ITEM_SELECTOR = 'div.item.active';
Bingo.GalleryManager.DELETE_LINK_SELECTOR = '.delete';
Bingo.GalleryManager.ROTATE_LINK_SELECTOR = '.rotate';
Bingo.GalleryManager.COVER_LINK_SELECTOR = '.cover';

Bingo.GalleryManager.MAIN_CLASS = 'main';

Bingo.GalleryManager.previousOrder = null;

Bingo.GalleryManager.init = function (selector, configuration) {
    if (configuration.hasOwnProperty('sorting')) {
        const userOptions = configuration.sorting.options;
        const binding = configuration.sorting.binding;
        const options = {
            onUpdate(event) {
                const elements = event.to;
                if (!elements || elements.hasOwnProperty('children')) {
                    return;
                }
                const output = Bingo.GalleryManager.extractHashes(elements.children);

                // Set first photo according to order not DOM
                Bingo.GalleryManager.resetMain(selector, (output.length > 0) ? output[0] : null);

                const data = {};
                data[binding.field] = output;
                const settings = {
                    url: binding.url,
                    method: 'post',
                    data,
                    'data-ajax-freeze': [selector],
                };
                $.nette.ajax(settings);
            },
            onChoose() {
                Bingo.GalleryManager.scrollDisable();
            },
            onEnd() {
                Bingo.GalleryManager.scrollEnable();
            },
        };
        $.extend(options, userOptions);
        const gallery = $(selector);
        if (gallery.length > 0) {
            Sortable.create(gallery[0], options);
            // iPhone/safari hack
            Bingo.GalleryManager.scrollDisable();
            Bingo.GalleryManager.scrollEnable();
        }
    }
    if (configuration.hasOwnProperty('deleting') && configuration.deleting.hasOwnProperty('enable') && configuration.deleting.enable) {
        if (configuration.deleting.hasOwnProperty('carousel') && configuration.deleting.carousel) {
            $(`${selector} ${Bingo.GalleryManager.DELETE_LINK_SELECTOR}`).click(() => {
                // intentionally empty
            });
        }
        if (configuration.deleting.hasOwnProperty('sortable') && configuration.deleting.sortable) {
            $(`${selector} ${Bingo.GalleryManager.DELETE_LINK_SELECTOR}`).click(function (event) {
                const brick = $(this).closest(Bingo.GalleryManager.BRICK_SELECTOR);
                const hash = brick.attr('data-hash');
                brick.remove();
                if (configuration.deleting.hasOwnProperty('maintainOrder') && configuration.deleting.maintainOrder) {
                    // Update previous order
                    if (Bingo.GalleryManager.previousOrder) {
                        const index = Bingo.GalleryManager.previousOrder.indexOf(hash);
                        if (index > -1) {
                            Bingo.GalleryManager.previousOrder.splice(index, 1);
                        }
                    }
                    const firstInDom = $(`${selector} [data-hash]`).first().attr('data-hash');
                    Bingo.GalleryManager.resetMain(selector, (Bingo.GalleryManager.previousOrder) ? Bingo.GalleryManager.previousOrder[0] : firstInDom);
                }
                event.preventDefault();
                event.stopPropagation();
            });
        }
    }
};

Bingo.GalleryManager.scrollDisable = function () {
    document.addEventListener('touchmove', () => {
        e.preventDefault();
    }, {
        passive: false,
    });
};

Bingo.GalleryManager.scrollEnable = function () {
    $(document).off('touchmove');
};

Bingo.GalleryManager.resetMain = function (selector, hash) {
    // Set first photo according to order not DOM
    $(`${selector} [data-hash]`).removeClass('main');
    if (hash) {
        $(`${selector} [data-hash=${hash}]`).addClass('main');
    }
};
Bingo.GalleryManager.extractHashes = function (elements) {
    const output = [];
    for (let i = 0; i < elements.length; i++) {
        const temp = elements[i].getAttribute('data-hash');
        if (temp) {
            output.push(temp);
        }
    }
    return output;
};
